import { mapFragmentFeaturesToModel } from '@shure/shared/angular/data-access/system-api/mappers';

import { CoverageAnalogOutputChannel } from '../../api/models';
import { DeviceCoverageAudioChannelFragment } from '../graphql/generated/device-coverage-audio-channel.generated';

import { mapDeviceCoveragePassiveSpeakers } from './coverage-audio-channel-passive-speaker.mapper';

export function mapAnalogOutputChannelFromSysApi(
	fragment: DeviceCoverageAudioChannelFragment
): CoverageAnalogOutputChannel {
	const { type, passiveSpeakers } = fragment.features.passiveSpeakers ?? {};
	return {
		id: fragment.id,
		features: mapFragmentFeaturesToModel(fragment, {
			passiveSpeakers: () => ({
				value: type
					? {
							type,
							passiveSpeakers:
								passiveSpeakers?.map((passiveSpeakerFragment) =>
									mapDeviceCoveragePassiveSpeakers(passiveSpeakerFragment)
								) ?? []
						}
					: undefined
			})
		})
	};
}
